import React, { useEffect, useState } from "react";

import { getAccessMatrix, getMembers } from "../services/accessService";
import type { Member, Role } from "../types/access";
import AccessMatrix from "./AccessMatrix";
import CommonConfiguration from "./CommonConfiguration";
import ManageRoles from "./ManageRoles";
import SideNav from "./SideNav";
import TopNavbar from "./TopNavbar";
import UserEligibility from "./UserEligibility";
import WidgetConfiguration from "./WidgetConfiguration";

const AccessMatrixContainer: React.FC = () => {
  const [drawerOpen, setDrawerOpen] = useState(true);
  const [active, setActive] = useState<"matrix" | "daraja" | "widget" | "common" | "user">(
    "daraja"
  );
  const [members, setMembers] = useState<Member[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const [loading, setLoading] = useState(true);

  const updatedBy = "Admin";

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    setLoading(true);
    try {
      const matrixResp = await getAccessMatrix();
      const membersResp = await getMembers("DEFAULT");

      setRoles(matrixResp.roles || []);
      setMembers(membersResp?.data?.members || []);
    } catch {
      console.error("Failed to load initial data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-5">Loading...</div>;

  return (
    <div className="bg-[#f6f4ef] min-h-screen">
      <TopNavbar drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />

      <div className="flex">
        <SideNav drawerOpen={drawerOpen} active={active} setActive={setActive} />

        <div
          className={`flex-1 transition-all duration-500 ${
            drawerOpen ? "ml-[260px]" : "ml-[64px]"
          }`}
        >
          <div className="p-5">
            {active === "matrix" && <AccessMatrix />}

            {active === "daraja" && (
              <ManageRoles
                open={true}
                onClose={() => {}}
                members={members}
                roles={roles}
                createdBy={updatedBy}
              />
            )}
            {active === "widget" && <WidgetConfiguration />}
            {active === "common" && <CommonConfiguration />}
            {active === "user" && <UserEligibility members={members} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessMatrixContainer;
